// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.10";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://d4dc8ac679a6acaf33fd4c2951d93083@o4510380394872832.ingest.de.sentry.io/4510381177176144",

  environment:
    process.env.ENVIRONMENT || process.env.NEXT_PUBLIC_ENVIRONMENT || 'unknown',

  // Add optional integrations for additional features
  integrations: [
    Sentry.replayIntegration(),
  ],
  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Define how likely Replay events are sampled.
  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // Define how likely Replay events are sampled when an error occurs.
  replaysOnErrorSampleRate: 1.0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  // Enable sending user PII (Personally Identifiable Information)
  // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#sendDefaultPii
  sendDefaultPii: false,

  beforeBreadcrumb(breadcrumb, hint) {
    let newBreadcrumb = breadcrumb;
    if (breadcrumb.category === 'form' || breadcrumb.category === 'application') {
      // Log the breadcrumb data to the console for debugging
      const keysToTruncate = ['portrait', 'fullFigure', 'headAndShoulders', 'sideOn', 'guardianPhoto', 'image_full_figure', 'image_head_and_shoulders', 'image_side_on', 'image_portrait', 'guardian_image'];

      // This is to ensure that when we truncate, we don't mutate the original breadcrumb object
      newBreadcrumb = {
        ...breadcrumb,
        data: {
          ...breadcrumb.data,
        },
      };

      keysToTruncate.forEach(key => {
        if (newBreadcrumb?.data && newBreadcrumb.data[key]) {
          // Truncate the data to the first 100 characters
          newBreadcrumb.data[key] = '** TRUNCATED **';
        }
      })
    }
    return newBreadcrumb; // Return the breadcrumb to be sent
  }
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
